// extracted by mini-css-extract-plugin
export default {"spacer":"comment-spacer-module-spacer-SB64Z","icon":"comment-spacer-module-icon-i0scE","body":"comment-spacer-module-body-H+CSq"};